import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Container, Alert, Form, Button } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { StoreContext } from 'src/stores/mobx/RootStore';

import BaseNavigation from 'src/components/navigation/BaseNavigation';
import { LinksForDeviseForm } from 'src/components/navigation/NavNewSession';
import { useFormValues, submitAsForm } from 'src/utilities/FormHelper';
import { aviatorNavigationToApp } from 'src/utilities/routesUtils';
import { capitalizeWords } from 'src/utilities/textHelper';

const Password = () => {
  const { userStore } = useContext(StoreContext);
  const { currentRoute, extraRules, deviseMappings } = userStore;

  const [errors, setErrors] = useState({});
  const [form, setForm] = useFormValues({
    email: '',
  });

  const handlePasswordnSubmit = async ({ values, url }) => {
    const response = await submitAsForm({
      url, form: values, prefix: 'user', method: 'POST'
    });

    return {
      status: response.status,
      ...(await response.json())
    };
  };

  useEffect(() => {
    userStore.fetchDeviseMappings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e?.preventDefault();
    const url = '/users/password';
    const values = form;
    const confirmationResult = await handlePasswordnSubmit({ values, url });

    if (confirmationResult.status === 200) {
      userStore.setDeviseErrorMessages(confirmationResult.message);
      aviatorNavigationToApp('/sign_in');
    } else if (confirmationResult.status === 400) {
      setErrors(confirmationResult.message);
    }
  }, [form, userStore]);

  if (!deviseMappings) { return null; }

  return (
    <div>
      <BaseNavigation />
      <Container className="mt-5">
        {Object.keys(errors).length >= 1 && (
          <Alert variant="warning">
            {
              Object.entries(errors).map(([key, value]) => (
                  <>
                    {capitalizeWords(key)} {value.join(', ')}
                    <br />
                  </>
                ))
            }
          </Alert>
        )}

        <h3 className="mb-3">Forgot your password?</h3>
        <Form className="mb-3" onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label column="lg">
              Email
            </Form.Label>
            <Form.Control
              type="text"
              name="email"
              value={form.email}
              onChange={setForm}
            />
          </Form.Group>
          <Button variant="primary" type="submit" className="mb-3">
            Send me reset password instructions
          </Button>
        </Form>
        {LinksForDeviseForm(currentRoute, extraRules, deviseMappings)}
      </Container>
    </div>
  );
};

export default observer(Password);
